import { ElementsArray } from 'polotno/model/group-model';

export function lockElements(elements: ElementsArray) {
    elements.forEach(element => {
        element.set({
            draggable: false,
            contentEditable: false,
            styleEditable: false,
            resizable: false,
            removable: false,
        });
    });
}
